import { Component, OnInit } from '@angular/core'
import {
  RootState,
  selectCurrentUser,
  selectUserPolicy,
  User,
} from '@helios/state-management'
import { TelemetryService } from '@helios/telemetry'
import { Store } from '@ngrx/store'
import { environment } from 'environments/environment'
import { filter, take, takeWhile, tap } from 'rxjs/operators'

@Component({
  selector: 'hs-ad-blocker',
  templateUrl: './ad-blocker.component.html',
  styleUrls: ['./ad-blocker.component.scss'],
})
export class AdBlockerComponent implements OnInit {
  constructor(
    private readonly telemetryService: TelemetryService,
    private readonly store: Store<RootState>,
  ) {}

  ngOnInit(): void {
    // wait for user login to complete
    this.store
      .select(selectCurrentUser)
      .pipe(
        takeWhile(user => user == null, true),
        filter((user): user is User => user != null),
        take(1),
        tap(user => this.onUserLogin(user)),
      )
      .subscribe()
  }

  onUserLogin(user: User) {
    if (!user) return
    this.store
      .select(selectUserPolicy)
      .pipe(
        filter(policy => policy != undefined),
        take(1),
      )
      .subscribe(userPolicy => {
        if (userPolicy) {
          this.telemetryService.init(user, userPolicy, environment.environment)
        }
      })
  }
}
